module.exports = __webpack_public_path__ + "assets/img/life-7.77f265de.jpg";